import { useState } from "react";
import ItemList from "./ItemList";

const RestaurantCategory = ({ data, showItems, setShowIndex, dummy }) => {
  const handleClick = () => {
    setShowIndex();
  };
  return (
    <div className="w-11/12 mx-auto my-4 rounded-lg shadow-md border border-gray-200">
      {/* Header */}
    
        <div
          className="flex justify-between items-center cursor-pointer p-4 bg-white rounded-lg hover:shadow-lg transition-shadow duration-300"
          onClick={handleClick}
        >
          <span className="font-semibold text-gray-800 text-lg">
            {data.title} ({data.itemCards.length})
          </span>
          <span>⬇️</span>
        </div>
        
      {/* Item List */}
        { showItems  &&
        <div className="bg-gray-50 rounded-b-lg p-4">
        <ItemList items={data.itemCards} /*dummy={dummy} */ />
        </div>}
      </div>
    
  );
};

export default RestaurantCategory;